<div *ngIf="(overlayStatus$ | async) as overlayStatus" class="planner-view planner-view--force-min-width-override"
    (click)="checkIfClickedOnBackdrop($event)"
    [class.planner-view--backdrop]="overlayStatus !== OverlayStatusEnum.Idle">
    <div [class.pointer-events-none]="overlayStatus !== OverlayStatusEnum.Idle" class="main-filters">
        <div class="main-filters__column-1">
            <select (change)="daysModeChanged($event)">
                <option *ngFor="let dayMode of daysModeOptions" [value]="dayMode.value">{{dayMode.displayName}}</option>
            </select>
        </div>
        <div class="main-filters__column-2" *ngIf=" (this.plannerConfiguration$ | async) as config">
            <planer-range-selection (selectedDateRangeChanged)="plannerDateRangeChanged($event)"
                [selectedDateRange]="{ start: config.firstDay, end: config.lastDay}"
                [selectedDaysMode]="config.daysMode" />
        </div>
        <div class="flexContent gap-4 main-filters__column-3">
            <mat-button-toggle-group (change)="categoryChanged($event)">
                <mat-button-toggle *ngFor="let category of vehicleCategoryFilter$ | async"
                    [checked]="category.isSelected" [value]="category.ids"> {{ category.title }} </mat-button-toggle>
            </mat-button-toggle-group>

            <a mat-stroked-button href="#!/app/orderdelivery"
                *hasPermission="ROOT_SCOPE_VARIABLES.PERMISSIONS.PLANNING_DAILYPLAN.LOADINGUNLODINGVIEW">
                <mat-icon>local_shipping</mat-icon>
                Zał / Rozł
            </a>
        </div>
    </div>
    <div [class.pointer-events-none]="overlayStatus !== OverlayStatusEnum.Idle" class="planner-view__secondary-filters">

        <!-- <button class="action-button--white-background" type="button" mat-icon-button (click)="expandAll()"
            matTooltip="Rozwiń trasy z wieloma zleceniami">
            <mat-icon>unfold_more</mat-icon>
        </button>

        <button class="action-button--white-background" type="button" mat-icon-button (click)="collapseAll()"
            matTooltip="Zwiń trasy z wieloma zleceniami">
            <mat-icon>unfold_less</mat-icon>
        </button> -->
        <div matTooltip="Data ostatniej aktualizacji - włącz automatyczną aktualizację"
            class="planner-view__last-update-time-box  user-select-none layout-px-4 layout-py-4">
            <mat-slide-toggle class="mat-slide-toggle-system-colors" [(ngModel)]="isAutoRefreshEnabled"
                labelPosition="before">
                {{ lastUpdateDate$ | async | date :'HH:mm:ss'}}
            </mat-slide-toggle>
        </div>

        <button class="action-button--white-background" type="button"
            [disabled]="overlayStatus !== OverlayStatusEnum.Idle" mat-icon-button (click)="refreshRoutesClick()"
            matTooltip="Odśwież trasy">
            <mat-icon>sync</mat-icon>
        </button>

        <button class="action-button--white-background" type="button"
            *hasPermission="ROOT_SCOPE_VARIABLES.PERMISSIONS.PLANNING_DAILYPLAN.PLANNING.FINISH"
            [disabled]="overlayStatus !== OverlayStatusEnum.Idle" (click)="sendRoutesToDrivers()" mat-icon-button
            matTooltip="Wyślij trasy do kierowców">
            <mat-icon>sync_alt</mat-icon>
        </button>


        <!-- <button class="action-button--white-background" type="button" disabled mat-icon-button
            matTooltip="Pobierz w formacie Excel">
            <mat-icon>system_update_alt</mat-icon>
        </button> -->

        <div>
            <select (change)="regionChanged($event)">
                <option selected [value]="null" class="disabled-text-color"> Wyszukaj po Spółce </option>
                <option *ngFor="let region of regions$ | async" [value]="region.Id">{{ region.Name }}</option>
            </select>
        </div>
        <div>
            <input type="text" [formControl]="mainSearchControl" placeholder="szukaj" />
        </div>

    </div>
    <div class="progress-bar-panel">
        <mat-progress-bar *ngIf="overlayStatus === OverlayStatusEnum.Working" mode="indeterminate"></mat-progress-bar>
    </div>


    <div [class.pointer-events-none]="overlayStatus !== OverlayStatusEnum.Idle" class="flex-grow flexContent">
        <!-- panel kierowców i harmonogramu  -->
        <div class="flex-grow flexContent flexColumn layout-px-4">
            <div class="flex gap-2 pr-8">
                <div
                    class="planner-view--panels-h driver-box-wrapper flexContent flexColumn align-center layout-px-4 layout-mr-4">
                    <div>Kierowcy
                    </div>
                    <input type="text" [formControl]="driverSearchControl" placeholder="szukaj" />
                </div>


                <div *ngFor="let day of displayedDays$ | async; let first = first; let last = last; let index = index "
                    class="displayed-days flex-grow flexContent spacebetween align-center">

                    <div>
                        <button type="button" mat-icon-button *ngIf="first" (click)="pageChanged(false)">
                            <mat-icon>arrow_back_ios_new</mat-icon>
                        </button>
                    </div>

                    <div class="flexContent flexColumn justify-center align-center">
                        <div>{{day | date: 'dd.MM.yyyy' }}</div>
                        <div class="font-weight-bolder">
                            <div
                                *ngIf="index === (this.plannerConfiguration$ | async)?.middleDayOfThePeriod; else emptyTemplate">
                                {{day | date: 'w' }}
                            </div>

                        </div>
                    </div>
                    <div>
                        <button type="button" mat-icon-button *ngIf="last" (click)="pageChanged()">
                            <mat-icon>arrow_forward_ios</mat-icon>
                        </button>

                        <div *ngIf="!last" class="displayed-days__cell-right-element">
                        </div>
                    </div>

                </div>
            </div>

            <div class="flex-grow ">
                <div #mainGrid class="main-grid " (dragover)="mainGridOnDragOverThrottled($event)"
                    (dragend)="mainGridOnDragEnd()">

                    <!-- grid element -->
                    <div *ngFor="let row of gridRowsFiltered$ | async; let rowIndex = index"
                        class="main-grid--grid-row">
                        <driver-box class="driver-box-wrapper" [driver]="row.driverVehicleInfo"
                            [isRowExpanded]="row.isRowExpanded" [showCollapseButtons]="row.rowExceededAllowableHeight"
                            (expandRow)="expandRow(row)" (collapseRow)="collapseRow(row)"></driver-box>

                        <ng-container *ngFor="let day of row.days;">

                            <ng-container [ngSwitch]="day.type">

                                <empty-day-box *ngSwitchCase="'Empty'" [day]="day" [driver]="row.driverVehicleInfo"
                                    class="grid-day"
                                    (orderDropped)="checkValidationBeforeOrderDropped($event, absenceMessageTemplate)"
                                    (addNewAbsence)="addNewAbsence($event, day, row.driverVehicleInfo, row)"></empty-day-box>

                                <!-- <absence-day-box *ngSwitchCase="'Absence'" [absences]="day.absences!"
                                    [driver]="row.driverVehicleInfo" class="grid-day"
                                    (addNewAbsence)="addNewAbsence($event, day, row.driverVehicleInfo, row)"></absence-day-box> -->

                                <div *ngSwitchCase="'None'" class="grid-day">
                                    <!-- placehold-er do momentu załadowania danych   -->
                                </div>

                                <ng-container *ngSwitchCase="'Routes'">

                                    <ng-container
                                        *ngIf="day.dayExceededAllowableHeight && !day.isDayExpanded; else expandedCellTemplate">
                                        <routes-box-collapsed class="grid-day" [routes]="day.routes" [day]="day"
                                            (collapsedCellClicked)="expandDay(row, day)">
                                        </routes-box-collapsed>
                                    </ng-container>

                                    <ng-template #expandedCellTemplate>
                                        <routes-box [routes]="day.routes" [day]="day" [driver]="row.driverVehicleInfo"
                                            class="grid-day"
                                            (orderDropped)="checkValidationBeforeOrderDropped($event, absenceMessageTemplate)"
                                            (editRoute)="routeEditCLick($event, routeEditJSTemplate)"
                                            (sendRouteToDriver)="sendRouteToDriver($event)"
                                            (editShipment)="editShipmentOnRoute($event)"
                                            (showConflicts)="showDayConflictsClick($event, absencesConflictTemplate)"
                                            (addNewAbsence)="addNewAbsence($event, day, row.driverVehicleInfo, row)"></routes-box>
                                    </ng-template>

                                </ng-container>

                            </ng-container>
                        </ng-container>
                    </div>

                </div>
            </div>
        </div>

        <!-- prawy panel -->
        <div class="planner-view--right-panel-width flexContent flexColumn">

            <div class="planner-view--panels-h flexContent flexColumn align-center layout-px-4 w-100p">
                <div>Zlecenia / zgłoszenia </div>
                <input type="text" [formControl]="ordersSearchControl" placeholder="szukaj" />
            </div>

            <div class="flex-grow pr-2">
                <div class="shipments-baskets mb-4" *ngIf="availableOrdersFiltered$ | async as availableOrders">
                    <div class="height-24 flexContent spacearound align-center shipments-baskets--bottom-border">
                        <span>
                            Zgłoszenia ({{availableOrders.length}})
                        </span>
                        <mat-icon
                            *hasPermission="ROOT_SCOPE_VARIABLES.PERMISSIONS.PLANNING_DAILYPLAN.PLANNING.ADDORDERS"
                            class="cursor-pointer" matRipple [matRippleCentered]="true" [matRippleUnbounded]="true"
                            [matRippleRadius]="20" (click)="showNewOrderPanel($event)">add</mat-icon>
                    </div>

                    <div class="shipments-baskets__order-list">
                        <ng-container *ngIf="!isLoadingOrders; else spinnerTemplate">
                            <ng-container *ngIf="availableOrders.length >0; else emptyDataTemplate">
                                <order-box *ngFor="let order of availableOrders" [order]="order"
                                    [showDateSection]="true" [dataObjectType]="DragObjectTypeEnum.ORDER"
                                    (editOrder)="editOrder($event)">
                                </order-box>
                            </ng-container>

                        </ng-container>

                    </div>
                </div>

                <div class="shipments-baskets" *ngIf="availableShipmentsFiltered$ | async as availableShipments">
                    <div class="height-24 flexContent spacearound align-center shipments-baskets--bottom-border">
                        <span>
                            Zlecenia ({{availableShipments.length}})
                        </span>
                        <mat-icon
                            *hasPermission="ROOT_SCOPE_VARIABLES.PERMISSIONS.PLANNING_DAILYPLAN.PLANNING.ADDSHIPMENTS"
                            class="cursor-pointer" matRipple [matRippleCentered]="true" [matRippleUnbounded]="true"
                            [matRippleRadius]="20" (click)="showNewShipmentPanel($event)">add</mat-icon>
                    </div>

                    <div class="shipments-baskets__order-list" (dragenter)="onDragOnShipmentEnter($event)"
                        (dragover)="onDragOnShipmentOver($event)" (dragleave)="onDragOnShipmentLeave()"
                        (drop)="onDropOnShipment($event)">

                        <ng-container *ngIf="!isOrderDragOverShipments else orderIsDragingTemplate">
                            <ng-container *ngIf="!isShipmentDragOverShipments else shipmentIsDragingTemplate">
                                <ng-container *ngIf="!isLoadingShipments; else spinnerTemplate">
                                    <ng-container *ngIf="availableShipments.length >0; else emptyDataTemplate">
                                        <order-box [showDateSection]="true" *ngFor="let order of availableShipments"
                                            [order]="order" (editShipment)="editShipment($event)">
                                        </order-box>
                                    </ng-container>
                                </ng-container>
                            </ng-container>
                        </ng-container>

                    </div>
                </div>
            </div>

        </div>
    </div>
</div>


<ng-template #routeEditJSTemplate>
    <ng-content select=".angular-js-planner-view-edit-route"></ng-content>
</ng-template>

<ng-template #spinnerTemplate>
    <epod-spinner isWorking="true" />
</ng-template>

<ng-template #emptyDataTemplate>
    <div class="shipments-baskets__empty-data-center-msg">Brak danych dla wybranego okresu</div>
</ng-template>

<ng-template #orderIsDragingTemplate>
    <div class="shipments-baskets__drag-placeholder pointer-events-none">
        <span>Przeciągnij zgłoszenie, aby utworzyć nowe zlecenie.</span>
    </div>
</ng-template>

<ng-template #shipmentIsDragingTemplate>
    <div class="shipments-baskets__drag-placeholder pointer-events-none">
        <span>Przeciągnij zlecenie, aby wycofać je z trasy.</span>
    </div>
</ng-template>

<ng-template #absencesConflictTemplate let-absences>

    <div class="layout-pb-10">
        <table mat-table [dataSource]="absences" class="mat-elevation-z1">
            <ng-container matColumnDef="dateTo">
                <th mat-header-cell *matHeaderCellDef> Data </th>
                <td mat-cell *matCellDef="let element">

                    {{ element.dateFrom | date: 'dd.MM.yyyy'}}
                    <span *ngIf="element.dateTo"> - {{ element.dateTo | date: 'dd.MM.yyyy'}}</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="typeTitle">
                <th mat-header-cell *matHeaderCellDef> Typ niedostępności </th>
                <td mat-cell *matCellDef="let element"> {{element.typeTitle}} </td>
            </ng-container>

            <ng-container matColumnDef="title">
                <th mat-header-cell *matHeaderCellDef> Opis </th>
                <td mat-cell *matCellDef="let element"> {{element.title}} </td>
            </ng-container>

            <ng-container matColumnDef="objectName">
                <th mat-header-cell *matHeaderCellDef> Obiekt </th>
                <td mat-cell *matCellDef="let element"> {{element.objectName}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="absencesDisplayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: absencesDisplayedColumns;"></tr>
        </table>
    </div>

</ng-template>

<ng-template #emptyTemplate>&nbsp;</ng-template>

<ng-template #absenceMessageTemplate let-message>
    <div class="flexContent text-align-center gap-16 flexColumn layout-px-4 drop-conflict-popup">
        <div class="font-weight-bolder">Uwaga</div>
        <div>{{message}}</div>

        <div>
            Czy nadal chcesz przypisać zlecenie do trasy?
        </div>
    </div>
</ng-template>